module.exports = __webpack_public_path__ + "static/img/kefu_new.b5723f61.png";